import React from 'react';
import {observer} from 'mobx-react';
import orderDetailStore from '@store/User/UserList/OrderDetailStore';

import OrderDetailPlanModal from '@ViewsDashboard/User/UserList/Order/OrderDetailPlanModal';
import OrderDetailMatchTableModal from '@ViewsDashboard/User/UserList/Order/OrderDetailMatchTableModal';
import OrderDetailTicketTableModal from '@ViewsDashboard/User/UserList/Order/OrderDetailTicketTableModal';

@observer
class OrderDetailModal extends React.Component {

    constructor(props) {
        super();
        if (props.expanded) {
            this.updateDatas(props.orderId)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.expanded) {
            this.updateDatas(nextProps.orderId);
        }
    }

    updateDatas(id) {
        //请求当前order数据
        orderDetailStore.getOrderDetail(id);
    }

    render() {
        // console.log(this.props);
        // orderDetailStore.getOrderDetail(this.props['orderId']);

        if (orderDetailStore.orderDetailData == undefined) {
            return (
                <div>数据加载中</div>
            )
        }

        let gapStyle = {
            padding: '10px'
        };

        return (
            <div>
                <OrderDetailPlanModal/>
                <div style={gapStyle}></div>
                <OrderDetailMatchTableModal/>
                <div style={gapStyle}></div>
                <OrderDetailTicketTableModal/>
            </div>

        )
    }

    componentWillMount() {
        //请求当前order数据
        // orderDetailStore.getOrderDetail(record.order_id);
    }

    componentDidMount() {
        // orderDetailStore.getOrderDetail(this.props['orderId']);
    }

    componentWillUnmount() {
        orderDetailStore.orderDetailData = undefined;
    }
}

export default OrderDetailModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/Order/OrderDetailModal.jsx